






















































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ImportacaoPagamentosStore from '@/components/RemuneracaoMedica/financeiro/Store/ImportacaoPagamentosStore'
import StatusChip from '@/components/RemuneracaoMedica/financeiro/components/StatusChip.vue'
import EventBus from '@/plugins/EventBus'
import { maskDateTime } from '@/utils/common'
import { STATUS_IMPORTACAO_ITEM_OPTIONS,
  statusImportacaoCor,
  statusImportacaoLabel,
  statusImportacaoItemCor,
  statusImportacaoItemLabel,
  tipoImportacaoLabel } from '@/utils/importacaoPagamentos'

@Component({
  components: {
    StatusChip,
  },
})
export default class ImportacaoDetalheModal extends Vue {
  loadingItens: boolean = false
  modalLinha: boolean = false
  linhaCampos: any[] = []

  statusImportacaoCor = statusImportacaoCor
  statusImportacaoLabel = statusImportacaoLabel
  statusImportacaoItemCor = statusImportacaoItemCor
  statusImportacaoItemLabel = statusImportacaoItemLabel
  tipoImportacaoLabel = tipoImportacaoLabel

  get store() {
    return getModule(ImportacaoPagamentosStore, this.$store)
  }

  get show() {
    return this.store.modalDetalhe
  }

  set show(value: boolean) {
    this.store.setModalDetalhe(value)
  }

  get importacao() {
    return this.store.importacaoSelecionada
  }

  get itens() {
    return this.store.itensList
  }

  get statusItemOptions() {
    return STATUS_IMPORTACAO_ITEM_OPTIONS
  }

  get linhaHeaders() {
    return [
      { text: 'Campo', value: 'campo', align: 'left', sortable: false },
      { text: 'Valor', value: 'valor', align: 'left', sortable: false },
    ]
  }

  get headers() {
    return [
      { text: 'Linha', value: 'numeroLinha', align: 'center', sortable: false },
      { text: 'Status', value: 'status', align: 'center', sortable: false },
      { text: 'Mensagem', value: 'mensagem', align: 'left', sortable: false },
      { text: 'Ações', value: 'actions', align: 'center', sortable: false },
    ]
  }

  get itensFiltroStatus() {
    return this.store.itensFiltroStatus
  }

  set itensFiltroStatus(value: any) {
    this.store.setItensFiltroStatus(value)
  }

  get itensPagina() {
    return this.store.itensPagina
  }

  set itensPagina(value: number) {
    this.store.setItensPagina(value)
  }

  get itensLength() {
    return Math.ceil(this.store.itensTotalRegistros / this.store.itensQtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  formatDateTime(date: string) {
    return maskDateTime(date)
  }

  async getItens() {
    this.loadingItens = true
    await this.store.getImportacaoItens()
    this.loadingItens = false
  }

  async aplicarFiltroItens() {
    this.store.setItensPagina(1)
    await this.getItens()
  }

  verLinha(item: any) {
    this.linhaCampos = []
    try {
      const conteudo = JSON.parse(item.conteudoJson || '{}')
      this.linhaCampos = Object.keys(conteudo).map(campo => ({
        campo,
        valor: conteudo[campo] === null || conteudo[campo] === undefined ? '-' : String(conteudo[campo]),
      }))
    } catch (error) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Não foi possível interpretar o conteúdo desta linha.',
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.modalLinha = true
  }

  close() {
    this.show = false
  }
}
